import React from "react";
import { FieldProps } from "formik";
import cn from "classnames";

export interface IOption {
  id: number;
  name: string;
}

interface IProps {
  options: IOption[];
  id?: string;
  placeholder?: string;
}

const SelectField: React.SFC<FieldProps & IProps> = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  return (
    <select
      {...props}
      className={cn("form-control sel", { 'input-error': touched[field.name] && errors[field.name] })}
      onChange={(e: any) =>
        setFieldValue(field.name, +e.target.value || e.target.value)
      }
      value={field.value}
    >
      <option value="" disabled={true} hidden={true}>
        {props.placeholder}
      </option>
      {props.options.map(({ id, name }) => (
        <option key={id} value={id}>
          {name}
        </option>
      ))}
    </select>
  );
};

export default SelectField;
